const platformStorageQuery = `
query GetPlatformStorage($first: Int!, $skip: Int!) {
  org_storages(
    first: $first,
    skip: $skip,
    order: [updatedAt_DESC]
  ) {
    count
    edges {
      node {
        objectId
        total_bytes
        total_files
        breakdown
        createdAt
        updatedAt
        org_pointer {
          objectId
          nome
          stato
          tipo_istanza
          data_scadenza
          data_scadenza_giotto
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default platformStorageQuery;
